<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col>
          <h1 class="mt-n5">{{ $t('Asphalt delivery') }}</h1>
        </v-col>
      </v-row>
      <v-card>
        <v-card-text class="black--text">
          <Field :title="$t('AgreementNo')" :val="' '+delivery.AgreementNo"></Field>
          <Field :title="$t('DeliveryNo')" :val="delivery.No"></Field>
          <Field :title="$t('CustomerName')" :val="delivery.CustomerName"></Field>
          <Field :title="$t('ArticleName')" :val="delivery.ArticleName"></Field>
          <Field :title="$t('Earliest load time')" :val="formatDateNonUtc(delivery.LoadTimeEarliest)"></Field>
          <Field :title="$t('Latest load time')" :val="formatDateNonUtc(delivery.LoadTimeLatest)"></Field>

          <v-row no-gutters>
            <v-col cols="12" class="font-weight-bold">
              {{$t('Vehicle')}}:
            </v-col>
            <v-col cols="12">
              <v-select hide-details :items="vehiclesNum" v-model="vehicle" solo></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="text-center">
              <svg id="barcode"></svg>
            </v-col>
          </v-row>
        </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="preventLeave = false; $router.go(-1)">{{$t("Leave")}}</v-btn>
      </v-card-actions>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import Field from '@/modules/asphalt-delivery/components/Field'
import formatDate from '@/core/mixins/formatDate'
import JsBarcode from 'jsbarcode'
import { user } from '@/core/security'
import { isVehicleUser } from '@/modules/asphalt-delivery/asphalt-delivery'

export default {
  mixins: [formatDate],
  components: {
    Field
  },
  data () {
    return {
      vehiclesNum: [], // possible vehicle licenseplates
      vehicle: null, // selected vehicle licenseplate
      isVehicleUser: false,

      delivery: {
        AgreementNo: 0,
        No: 0,
        CustomerName: '',
        ArticleName: '',
        Foreman: '',
        LineForeman: '',
        LoadTimeLatest: '20000101',
        AmountDelivered: ''
      }
    }
  },
  watch: {
    vehicle: {
      handler (val) {
        this.$nextTick(() => {
          if (val) JsBarcode('#barcode', val + '|' + this.delivery.No, { width: 1.5, height: 105 })
        })
      },
      immediate: true
    }
  },
  async mounted () {
    // check if user is a VehicleUser ie. member of "VehicleUsers" group (user must create this hardcoded "VehicleUsers" usergroup)
    const isVehicleUserRes = await isVehicleUser()
    if (!isVehicleUserRes.failed) {
      this.isVehicleUser = isVehicleUserRes.data.isVehicleUser
    }

    if (this.$route.params.id) {
      const delivery = this.$route.params.id
      this.delivery = delivery

      // show only one licensePlate for VehicleUsers or all licensePlates for others
      if (this.isVehicleUser && user.token.User.includes('.')) {
        const licenseplateNo = user.token.User.split('.', 2)[1] // "SVS.AA0001.1" gives "AA0001.1"
        this.vehiclesNum = [licenseplateNo]
        // Defaults to users vehicle LicensePlate
        this.vehicle = licenseplateNo
      } else {
        this.vehiclesNum = delivery.VehiclesNum
        // Defaults to first vehicles LicensePlate - if many
        const [first] = delivery.VehiclesNum
        this.vehicle = first
      }
    }

    this.$nextTick(() => {
      this.loading = false
    })
  }
}
</script>
